// authSaga.ts

import { call, put, select, takeLatest } from 'redux-saga/effects';
import { clearPersistor } from 'src/utils/cleanUpSersistor';

import { API } from '../../api';
import {
  login,
  loginFailure,
  loginSuccess,
  logout,
  logoutFailure,
  logoutSuccess,
  setUserData,
} from '../reducers/authSlice';

import { errorHandler } from './common';

function* loginSaga (action: { payload: { username: string; password: string } }) {
  try {
    // @ts-ignore
    const response: any = yield call<any>(API.post, '/auth/admin/sign-in', action.payload, {
      headers: 'Content-Type: application/json',
    });
    const token = response.data?.data?.access_token;

    //@ts-ignore
    const userData: any = yield call<any>(API.get, '/users/me', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    yield put(setUserData(userData?.data?.data));
    yield put(loginSuccess(token));
  } catch (error: any) {
    alert(`${error?.response?.data?.detail}`);

    yield put(loginFailure());
  }
}

function* logoutSaga () {
  try {
    // Make an API call to invalidate the token on the server-side
    // @ts-ignore
    const token = yield select(state => state.auth.token);

    yield call(API.get, '/auth/logout', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    clearPersistor();

    yield put(logoutSuccess());
  } catch (error: any) {
    // @todo uncomment when /auth/refresh will working properly
    // yield errorHandler({
    //   error,
    //   recallCallback: logoutSaga,
    //   callback: function* () {
    //     yield put(logoutFailure());
    //   }
    // });
    clearPersistor();

    yield put(logoutSuccess());
  }
}

// Watcher Saga
export function* authSaga () {
  // @ts-ignore
  yield takeLatest(login().type, loginSaga);
  yield takeLatest(logout().type, logoutSaga);
}
